export const environment = {
  production: true,
  buildId: '3271617289321051',
  configFile: 'config.json',
};
